import { normalizeRecordResponse } from 'api';
import { client, computeHeaders } from 'queries';

export const homeQuery = async ({ req, params, query }) => {
	const formattedParams = {
		sortProp: 'createdAt',
		sortValue: 'desc',
		context: query.context ? query.context : ['ssr'],
	};
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/home`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};
